<div class="table-responsive" *ngIf="_isAnnual && !noDataAnnual">
  <table class="table">
    <thead>
      <tr>
        <th width="320">Currency: USD</th>
        <th *ngFor="let year of years" class="text-center">{{ year }}</th>
      </tr>
    </thead>
    <tbody>
      <!-- Existing Data -->
      <tr *ngFor="let record of allDataAnnual" [hidden]="isRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let year of years" class="text-center">
          {{ roundToTwoDecimals(record[year]) ?? '-' }}
        </td>
      </tr>

      <!-- New Price to Earning Data -->
      <tr *ngFor="let record of formattedPriceToEarning" [hidden]="isRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let year of years" class="text-center">
          {{ roundToTwoDecimals(record[year]) ?? '-' }}
        </td>
      </tr>
    </tbody>

  </table>

</div>
<div *ngIf="noDataAnnual && _isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
  <p>No Annual Data Available!</p>
</div>



<div class="table-responsive" *ngIf="!_isAnnual && !noDataQuarterly">
  <table class="table">
    <thead>
      <tr>
        <th width="320">Currency: USD</th>
        <th class="text-center" *ngFor="let quarter of quarters">{{ quarter }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let record of aDataQuarterly" [hidden]="isQuarterlyRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let quarter of quarters" class="text-center">
          {{ roundToTwoDecimals(record[quarter]) ?? '-' }}
        </td>
      </tr>



      <tr>
        <th class="" colspan="6">Solvency Ratios</th>
      </tr>

      <tr *ngFor="let record of bDataQuarterly" [hidden]="isQuarterlyRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let quarter of quarters" class="text-center">
          {{ roundToTwoDecimals(record[quarter]) ?? '-' }}
        </td>
      </tr>

      <tr>
        <th class="" colspan="6">Efficiency Ratios</th>
      </tr>
      <tr *ngFor="let record of cDataQuarterly" [hidden]="isQuarterlyRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let quarter of quarters" class="text-center">
          {{ roundToTwoDecimals(record[quarter]) ?? '-' }}
        </td>
      </tr>

      <tr>
        <th class="" colspan="6">Current Ratio</th>
      </tr>

      <tr *ngFor="let record of dDataQuarterly" [hidden]="isQuarterlyRowEmpty(record)">
        <td>
          <div class="d-flex align-items-center gap-1 justify-content-between">
            <div class="d-flex align-items-center gap-1">
              {{ getLabel(record.name) }}</div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
              src="../../../../../../assets/icons/icon-info.svg" /> -->
          </div>
        </td>
        <td *ngFor="let quarter of quarters" class="text-center">
          {{ roundToTwoDecimals(record[quarter]) ?? '-' }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="noDataQuarterly && !_isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
  <p>No Quarterly Data Available!</p>
</div>
